import VueSignaturePad from 'vue-signature-pad';

export default function installPlugins(app) {
  app.use(VueSignaturePad);
}
